export default __webpack_public_path__ + "static/media/revision.f6678a52.svg";